import axios from "axios";

const BASE = `${process.env.REACT_APP_API}/upload/imagem`;

export async function uploadImagem(categoria, arquivo) {
  const formData = new FormData();
  formData.append("arquivo", arquivo);

  const res = await axios.post(`${BASE}/${categoria}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data;
}
